import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GatewayBreadcrumbQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GatewayBreadcrumbQuery = { __typename?: 'Query', gateways?: { __typename?: 'GatewayList', items: Array<{ __typename?: 'Gateway', displayName: string } | null> } | null };

export type LocationBreadcrumbQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type LocationBreadcrumbQuery = { __typename?: 'Query', locations?: { __typename?: 'LocationList', items: Array<{ __typename?: 'Location', name: string } | null> } | null };


export const GatewayBreadcrumbDocument = gql`
    query GatewayBreadcrumb($id: Int!) {
  gateways(id: $id) {
    items {
      displayName
    }
  }
}
    `;

/**
 * __useGatewayBreadcrumbQuery__
 *
 * To run a query within a React component, call `useGatewayBreadcrumbQuery` and pass it any options that fit your needs.
 * When your component renders, `useGatewayBreadcrumbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGatewayBreadcrumbQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGatewayBreadcrumbQuery(baseOptions: Apollo.QueryHookOptions<GatewayBreadcrumbQuery, GatewayBreadcrumbQueryVariables> & ({ variables: GatewayBreadcrumbQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GatewayBreadcrumbQuery, GatewayBreadcrumbQueryVariables>(GatewayBreadcrumbDocument, options);
      }
export function useGatewayBreadcrumbLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GatewayBreadcrumbQuery, GatewayBreadcrumbQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GatewayBreadcrumbQuery, GatewayBreadcrumbQueryVariables>(GatewayBreadcrumbDocument, options);
        }
export function useGatewayBreadcrumbSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GatewayBreadcrumbQuery, GatewayBreadcrumbQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GatewayBreadcrumbQuery, GatewayBreadcrumbQueryVariables>(GatewayBreadcrumbDocument, options);
        }
export type GatewayBreadcrumbQueryHookResult = ReturnType<typeof useGatewayBreadcrumbQuery>;
export type GatewayBreadcrumbLazyQueryHookResult = ReturnType<typeof useGatewayBreadcrumbLazyQuery>;
export type GatewayBreadcrumbSuspenseQueryHookResult = ReturnType<typeof useGatewayBreadcrumbSuspenseQuery>;
export type GatewayBreadcrumbQueryResult = Apollo.QueryResult<GatewayBreadcrumbQuery, GatewayBreadcrumbQueryVariables>;
export const LocationBreadcrumbDocument = gql`
    query LocationBreadcrumb($id: Int!) {
  locations(id: $id) {
    items {
      name
    }
  }
}
    `;

/**
 * __useLocationBreadcrumbQuery__
 *
 * To run a query within a React component, call `useLocationBreadcrumbQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationBreadcrumbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationBreadcrumbQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationBreadcrumbQuery(baseOptions: Apollo.QueryHookOptions<LocationBreadcrumbQuery, LocationBreadcrumbQueryVariables> & ({ variables: LocationBreadcrumbQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationBreadcrumbQuery, LocationBreadcrumbQueryVariables>(LocationBreadcrumbDocument, options);
      }
export function useLocationBreadcrumbLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationBreadcrumbQuery, LocationBreadcrumbQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationBreadcrumbQuery, LocationBreadcrumbQueryVariables>(LocationBreadcrumbDocument, options);
        }
export function useLocationBreadcrumbSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocationBreadcrumbQuery, LocationBreadcrumbQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationBreadcrumbQuery, LocationBreadcrumbQueryVariables>(LocationBreadcrumbDocument, options);
        }
export type LocationBreadcrumbQueryHookResult = ReturnType<typeof useLocationBreadcrumbQuery>;
export type LocationBreadcrumbLazyQueryHookResult = ReturnType<typeof useLocationBreadcrumbLazyQuery>;
export type LocationBreadcrumbSuspenseQueryHookResult = ReturnType<typeof useLocationBreadcrumbSuspenseQuery>;
export type LocationBreadcrumbQueryResult = Apollo.QueryResult<LocationBreadcrumbQuery, LocationBreadcrumbQueryVariables>;